angular.module('aprima-core-ui').factory('IcdCodeModal', ['$uibModal', '$rootScope', '$q', function ($modal, $rootScope, $q) {
    'use strict';

    function openModal(code, codeType) {
        var deferred = $q.defer();
        
        var modalInstance = $modal.open({
            animation: false,
            templateUrl: '/core-ui/views/directives/apIcdCodeModal.html',
            controller: 'apIcdCodeModalCtrl',
            resolve: {
                searchParams: function () {
                    return {
                        code: code,
                        codeType: codeType
                    };
                }
            },
            backdrop: 'static',
            windowClass: 'modal-full'
        });
        
        modalInstance.result.then(function(result){
            deferred.resolve(result);
        }).catch(function(err){
            deferred.reject(err);
            modalInstance.dismiss();
        });
        
        return deferred.promise;
    }
    
    return {
        openModal: openModal
    };
}]);